import FullScreenLoader from 'components/FullScreenLoader/FullScreenLoader';
import React, { createContext, useContext, useState } from 'react';

interface LoaderContextValue {
    showLoader: (props: { message?: string; highlightedText?: string }) => void;
    hideLoader: () => void;
}

interface LoaderState {
    isVisible: boolean;
    message?: string;
    highlightedText?: string;
}

const LoaderContext = createContext<LoaderContextValue | undefined>(undefined);

export const LoaderProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [state, setState] = useState<LoaderState>({
        isVisible: false,
        message: undefined,
        highlightedText: undefined,
    });

    const showLoader = ({ message, highlightedText }: { message?: string; highlightedText?: string }) => {
        setState({
            isVisible: true,
            message,
            highlightedText,
        });
    };

    const hideLoader = () => {
        setState({
            isVisible: false,
            message: undefined,
            highlightedText: undefined,
        });
    };

    return (
        <LoaderContext.Provider value={{ showLoader, hideLoader }}>
            {children}
            {state.isVisible && (
                <FullScreenLoader
                    message={state.message}
                    highlightedText={state.highlightedText}
                />
            )}
        </LoaderContext.Provider>
    );
};

export const useLoader = () => {
    const context = useContext(LoaderContext);
    if (!context) {
        throw new Error('useLoader must be used within a LoaderProvider');
    }
    return context;
};

export default LoaderContext;
